import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import Evented from 'dojo/Evented';
import RequestManager from 'more/RequestManager';


class EntityStore<X> extends compose(Evented) {
    private sourceList: Array<X>;
    keyAttribute: string = "ID";
    private sortAttribute: string = null;// "_order";
    private diffdata: EntityStoreData<X>;
    private _deletedData: Record<string, X>;

    loadEntityFromDatabase(entityID: string, entityClassname?: string, callback?: Function) {
        let requestManager = new RequestManager();

        try {
            window.standbyManager.addSpinner();
        } catch (ex) {

        }

        let data = {
            entityID: entityID,
            Classname: null
        };


        if (entityClassname) {
            data.Classname = entityClassname
        };

        requestManager.callfunction(
            "Webtool_API_Entity__LoadEntity",
           data,
            lang.hitch(this, this._onLoadEntityResponse, callback),
            lang.hitch(this, this._onLoadEntityError));
    }

    private _onLoadEntityResponse(callback: Function, response: X) {

        try {
            window.standbyManager.removeSpinner();
        } catch (ex) {

        }

        this.addEntry(response, "source");

        if (typeof (callback) == "function") callback();
    }

    private _onLoadEntityError(error: more.requestErrorMessage) {

        try {
            window.standbyManager.removeSpinner();
        } catch (ex) {

        }
    }

    /**
     * Prüft, ob es seit dem letzten Setup oder Commit Änderungen gab (deleted, changed, new)
     */
    isDirty(): boolean {

        if (this.diffdata) {
            if (this.diffdata.changed.length) return true;
            if (this.diffdata.deleted.length) return true;
            if (this.diffdata.new.length) return true;
        }
        return false;
    }

    /**
     * Gibt den Inhalt des Stores unterteilt nach changed, deleted und added zurück.
     */
    getDiffData(bNullIfNoDiff?: boolean): EntityStoreData<X>{
        if (!this.diffdata) this.reset();

        if (bNullIfNoDiff === true) {
            if (this.diffdata.changed.length == 0 && this.diffdata.deleted.length == 0 && this.diffdata.new.length == 0) return null;
        }

        return lang.clone(this.diffdata);
    }

    setDiffData(data: EntityStoreData<X>) {
        this.diffdata = data;
    }

    getKeyAttribute(): string {
        return this.keyAttribute;
    }

    /**
     * Gibt ein komplettes Array mit allen derzeit in der Liste befindlichen Objekten als Stringarray zurück.
     * Ausgenommen sind gelöschte Objekte ('deleted').
     * Mit dem target-Parameter können auch nur neue, geänderte, ursprüngliche oder bestehende (= ursprünglich + geändert) ausgegeben werden.
     */
    getCurrentCompleteValueList(target?: "new" | "changed" | "existing" | "source" | "deleted", sortBy?: string): Array<string> {
        let list = this.getCurrentCompleteList(target, sortBy);
        let result = [];
        for (let entry of list) {
            result.push(entry[this.keyAttribute]);
        }

        return result;
    }
    /**
     * Gibt die Gesamtzahl aller derzeit in der Liste befindlichen Objekten.
     * Ausgenommen sind gelöschte Objekte ('deleted').
     * Mit dem target-Parameter können auch nur neue, geänderte, ursprüngliche oder bestehende (= ursprünglich + geändert) ausgegeben werden.
     */
    getCurrentCompleteCount(target?: "new" | "changed" | "existing" | "source" | "deleted"): number {
        let list = this.getCurrentCompleteList(target);

        return list.length;
    }
    getDeletedValues(sortBy?: string): Array<string> {
        if (!this.diffdata) this.reset();

        return this.diffdata.deleted;
    }
    getDeletedEntities(sortBy?: string): Array<X> {
        let keys = this.getDeletedValues();
        let entities: Array<X> = [];
        for (let value of keys) {
            let entity = this._deletedData[value];

            if (entity) entities.push(entity);
        }

        return entities;
    }
    /**
     * Gibt ein komplettes Array mit allen derzeit in der Liste befindlichen Objekten zurück.
     * Ausgenommen sind gelöschte Objekte ('deleted'), außer target ist 'all'
     * Mit dem target-Parameter können auch nur neue, geänderte, ursprüngliche oder bestehende (= ursprünglich + geändert) ausgegeben werden.
     */
    getCurrentCompleteList(target?: "new" | "changed" | "existing" | "source" | "deleted" | "all", sortBy?: string, idOnly?: boolean): Array<X> {

        let list = [];
        let idList = [];
        if (target == "deleted") return this.getDeletedEntities(sortBy);

        if (!target || target == "existing" || target == "source" || target == "changed" || target == "all") {
            if (this.sourceList?.length) {
                for (let entry of this.sourceList) {
                    let indexDel = this.getIndexOfDataKey(entry[this.keyAttribute], "deleted");
                    let indexChanged = this.getIndexOfDataKey(entry[this.keyAttribute], "changed");

                    if (indexDel == -1 || target == "all") {
                        // in die Liste aufnehmen, wenn das Objekt nicht gelöscht worden ist oder target all
                        if (indexChanged != -1) {
                            // das geänderte Objekt verwenden, falls es geändert ist.
                            if (!target || target == "changed" || target == "existing" || target == "all") {
                                list.push(this.diffdata.changed[indexChanged]);
                            }
                        } else {
                            if (!target || target == "source" || target == "existing" || target == "all") {
                                // ansonsten das ursprüngliche Objekt in die Liste
                                list.push(entry);
                            }
                        }
                    }
                }
            }
        }
        // danach die neu hinzugefügten Einträge
        if (!target || target == "new" || target == "all") {
            if (this.diffdata) {
                
                for (let entry of this.diffdata.new) {
                    list.push(entry);
                }
            }
        }

        // Sortieren ??? oder interessiert uns das eigentlich nicht?
        let sortProperty = this.sortAttribute;

        if (sortBy)
            sortProperty = sortBy;

        if (sortProperty) {

            let compareFuctionDESC = function (a, b) {

                let fa = a[sortProperty];
                let fb = b[sortProperty];
                if (fa < fb) {
                    return 1;
                }
                if (fa > fb) {
                    return -1;
                }
                return 0;
            }

            let compareFuctionASC = function (a, b) {

                let fa = a[sortProperty];
                let fb = b[sortProperty];
                if (fa < fb) {
                    return 1;
                }
                if (fa > fb) {
                    return 1;
                }
                return 0;
            }

            list.sort(compareFuctionASC);
        }
        for (let entry of list) {
            idList.push(entry[this.getKeyAttribute()]);
        }
        if (idOnly) return idList;
        else return list;
    }

    /**
     * Der Entitystore meldet sich nach dem Setup mit einem 'dataset'-Event.
     * @param data
     * @param keyAttribute
     * @param sortAttribute
     */
    setup(data: Array<X>, keyAttribute: string = "ID", sortAttribute?: string) {

        this.reset();

        if (data) {
            this.sourceList = lang.clone(data);
        }
        else {
            this.sourceList = new Array<X>();
        }

        if (keyAttribute) this.keyAttribute = keyAttribute;
        if (sortAttribute) this.sortAttribute = sortAttribute;

        this.emit("dataset");
    }

    /**
     * Setzt alle Differenzdaten zurück, behält die ursprüngliche Liste aber bei.
     */
    reset() {
        this.diffdata = {
            changed: [],
            deleted: [],
            new: []
        };

        this._deletedData = {};

        if (!this.sourceList) {
            this.sourceList = [];
        }

    }

    /**
     * Entfernt alle Daten und Differenzdaten aus dem Store.
     */
    empty() {
        this.sourceList = [];
        this.reset();
    }

    /** 
     * "Speichert" alle Differenzdaten. Gelöschte Einträge werden entfernt, hinzugefügte und geändert kommen in die ursprüngliche Liste.
     * Der Store verhält sich nach dem Commit so, als wäre sein derzeitiger Zustand der ursprüngliche.
     */
    commit() {
        if (this.diffdata) {
            while (this.diffdata.deleted.length) {
                let entryID = this.diffdata.deleted[0];
                let index = this.getIndexOfDataKey(entryID, "existing");
                if (index != -1) this.sourceList.splice(index, 1);
            }

            while (this.diffdata.changed.length) {
                let entry = this.diffdata.changed[0];
                let index = this.getIndexOfDataKey(entry[this.keyAttribute], "existing");
                if (index != -1) this.sourceList.splice(index, 1);
                this.addEntry(entry, "source");
            }

            while (this.diffdata.new.length) {
                let entry = this.diffdata.new[0];
                this.addEntry(entry, "source");
            }
        }

        this.reset();
    }

    /** Verwirft alle Änderungen (new, changed) und stellt den Zustand seit dem letzten Setup oder Commit her. */
    rollback() {
        let backup = lang.clone(this.sourceList);
        this.setup(backup);
    }
    /**
     * Ermittelt anhand einer neuen Gesamtliste, welche Einträge im Vergleich zum vorherigen Datenstand hinzugefügt oder entfernt wurden.
     */
    updateFromList(data: Array<X>, bForceChangeEmit?: boolean) {
        if (!data) return;

        this.reset();
        let alreadyExisting = []
        let entriesRemoved = [];
        let entriesAdded = [];

        for (let compareEntry of data) {
            if (this.isEntityExisting(compareEntry)) {
                alreadyExisting.push(compareEntry)
            } else {
                entriesAdded.push(compareEntry);
            }
        }


        for (let existingEntry of this.sourceList) {
            let existingKey = existingEntry[this.keyAttribute];
            let stillExisting = false;
            for (let compareEntry of data) {
                if (compareEntry[this.keyAttribute] == existingKey) {
                    stillExisting = true;
                    break;
                }
            }

            if (!stillExisting) {
                entriesRemoved.push(existingEntry);
            }
        }
        for (let entry of entriesRemoved) {
            this.deleteEntry(entry);
        }


        for (let entry of entriesAdded) {
            this.addEntry(entry, "new");
        }

        if (!entriesAdded.length && !entriesRemoved.length && bForceChangeEmit === true) {
            // gar keine Änderung? trotzdem ein change auslösen, weil manche Elemente warten auf eine Reaktion wenn was hin- und wieder hergewechselt wird
            this.emit("change", this.getCurrentCompleteList());
        }
    }
    /**
     * Ein neues Objekt in den Store einfügen, gibt die ID des Objekts zurück. 
     * Das Objekt wird als "new" im Store behandelt, alternativ kann ein Store-fremdes Objekt auch via target-Parameter gezielt als changed oder deleted hinterlegt werden und wird dadurch dem Store hinzugefügt.
     * Bitte beachten: Das neue Objekt sollte trotz Neu-Status eine eindeutige ID erhalten, damit spätere Manipulationen erkannt werden können!
     * Falls kein ID-Attribut angegeben ist, erstellt der Store eine zufällige ID.
     * @param data Array mit den einzufügenden Objekten
     * @param target
     * @returns ID-Array der tatsächlich eingefügten Objekte
     */
    addEntries(data: Array<X>, target?: "new" | "changed" | "deleted" | "source"): Array<string> {
        if (!data || !data.length) return [];
        let returnValues = [];
        for (let entry of data) {
            let result = this.addEntry(entry, target);
            if (result) returnValues.push(result);
        }

        return returnValues;
    }
    /**
     * Ein neues Objekt in den Store einfügen, gibt die ID des Objekts zurück. 
     * Das Objekt wird als "new" im Store behandelt, alternativ kann ein Store-fremdes Objekt auch via target-Parameter gezielt als changed oder deleted hinterlegt werden und wird dadurch dem Store hinzugefügt.
     * Bitte beachten: Das neue Objekt sollte trotz Neu-Status eine eindeutige ID erhalten, damit spätere Manipulationen erkannt werden können!
     * Falls kein ID-Attribut angegeben ist, erstellt der Store eine zufällige ID.
     * @param data
     * @param target
     * @returns ID des eingefügten Objekts
     */
    addEntry(data: X, target?: "new" | "changed" | "deleted" | "source", suppressChange?: boolean): string {
        if (!data) return;

        let newEntry: X = lang.clone(data);

        let dataID = newEntry[this.keyAttribute];
        // if (!dataID) return; // naja, nicht raus, wenns neu ist, kann die ID ja durchaus leer sein :D
        if (!dataID) {
            dataID = "new_" + (Math.random() * 100000000).toFixed(0);
            newEntry[this.keyAttribute] = dataID;
        }

        if (!this.diffdata) this.reset();

        let i = this.getIndexOfDataKey(dataID, "existing");

        if (target) {
            if (target == "changed") {
                this.changeEntry(data, true);
                return dataID;
            }

            else if (target == "deleted") {
                this.deleteEntry(data, true);
                return dataID;
            }

            else if (target == "source") {
                if (i == -1) {
                    // existiert nicht, hier einfügen:
                    this.sourceList.push(data);
                } else {
                    // existiert schon: an genau der Stelle ersetzen
                    this.sourceList.splice(i, 1, data);
                }
            }

            else if (i != -1) {
                // existiert bereits, aber soll als "new" rein? das macht keinen Sinn...
                // immerhin war es ja schon in der Sourcelist des Stores
            }
        }
        

        if (!target) {
            // gibts das schon? dann raus:
            if (i != -1) {
                i = this.getIndexOfDataKey(dataID, "deleted");
                let bChanged = i != -1;
                while (i != -1) {
                    this.diffdata.deleted.splice(i, 1);
                    i = this.getIndexOfDataKey(dataID, "deleted");
                }
                if (this._deletedData[dataID]) {
                    this._deletedData[dataID] = null;
                    bChanged = true;
                }
                if (suppressChange !== true && bChanged) {
                    this._delayEmitChanged();
                }
                return dataID;
            }

                
        }

        // überall sonst rauswerfen:
        i = this.getIndexOfDataKey(dataID, "new");
        while (i != -1) {
            this.diffdata.new.splice(i, 1);
            i = this.getIndexOfDataKey(dataID, "new");
        }

        i = this.getIndexOfDataKey(dataID, "deleted");
        while (i != -1) {
            this.diffdata.deleted.splice(i, 1);
            i = this.getIndexOfDataKey(dataID, "deleted");
        }
        this._deletedData[dataID] = null;

        i = this.getIndexOfDataKey(dataID, "changed");
        while (i != -1) {
            this.diffdata.changed.splice(i, 1);
            i = this.getIndexOfDataKey(dataID, "changed");
        }

        if (target != "source") {
            this.diffdata.new.push(newEntry);
            if (suppressChange !== true) {
                this.emit("added", newEntry);
            }
        } else {
            if (suppressChange !== true) {
                this.emit("sourceChanged", newEntry);
            }
        }
        if (suppressChange !== true) {
            this._delayEmitChanged();
        }
        return dataID;
    }

    isEntityNew(entityOrID: Object | string) {
        let dataID = "";
        if (typeof (entityOrID) == "string") {
            dataID = entityOrID;
        } else if (typeof (entityOrID) == "object") {
            dataID = entityOrID[this.keyAttribute];
        }

        if (dataID) {
            return this.getIndexOfDataKey(dataID, "new") != -1;
        }

        return false;
    }
    isEntityChanged(entityOrID: Object | string) {
        let dataID = "";
        if (typeof (entityOrID) == "string") {
            dataID = entityOrID;
        } else if (typeof (entityOrID) == "object") {
            dataID = entityOrID[this.keyAttribute];
        }

        if (dataID) {
            return this.getIndexOfDataKey(dataID, "changed") != -1;
        }

        return false;
    }
    isEntityDeleted(entityOrID: Object | string) {
        let dataID = "";
        if (typeof (entityOrID) == "string") {
            dataID = entityOrID;
        } else if (typeof (entityOrID) == "object") {
            dataID = entityOrID[this.keyAttribute];
        }

        if (dataID) {
            return this.getIndexOfDataKey(dataID, "deleted") != -1;
        }

        return false;
    }

    getComplexProperty(entity: Object, path: string): any {
        if (!entity) return null;

        let pathParts = path.split('.'); // array mit dem komplexen Attributstring
        if (pathParts.length < 1) { 
            return null;
        }

        try {
            let currentAttribute = pathParts.shift();
            if (typeof (entity[currentAttribute]) != "undefined") {

                let attrFound = true;
                let subEntity = entity[currentAttribute];

                if (pathParts.length >= 1) // es gibt unterebenen!
                {
                    if (typeof (subEntity) == "object") {

                        if ((subEntity as Date).getTime && (subEntity as Date).getUTCDate) {
                            // das ist ein Datum, weiter kommen wir also nicht
                            return subEntity;
                        }
                        else {

                            // die nächsten Ebenen zusammenbauen und rekursiv aufrufen

                            let subPath = pathParts.join(".");

                            //console.log("PitHelper getnextlevel", subAttributes);
                            return this.getComplexProperty(subEntity, subPath);
                        }
                    }
                }

                return subEntity;
            }
        } catch (ex) {

        }
        return null;
    }

    isEntityExisting(entityOrValue: X | string, keyAttributePath?: string, includeNew: boolean = false, includeIfDeleted: boolean = false ) {
        let dataID = "";
        if (typeof (entityOrValue) == "string") {
            dataID = entityOrValue;
        } else if (typeof (entityOrValue) == "object") {
            dataID = entityOrValue[this.keyAttribute];

            if (keyAttributePath) {
                dataID = this.getComplexProperty(entityOrValue, keyAttributePath);
            }
        }

        if (dataID) {
            let result = this.getIndexOfDataKey(dataID, "existing", keyAttributePath) != -1;
            if (!result && includeNew === true) {
                result = this.getIndexOfDataKey(dataID, "new", keyAttributePath) != -1;
            }
            if (result == true && includeIfDeleted !== true) {
                result = this.getIndexOfDataKey(dataID, "deleted", keyAttributePath) == -1;
            }

            return result;
        }

        return false;
    }
    /**
     * Entfernt ein Element aus dem Store.
     * Falls das Entity vorher bereits "existent" war, wird es im Store als "deleted" hinterlegt.
     * Falls das Entity noch nicht im Store vorhanden war, führt delete zum Entfernen aus der "new"-Liste. Wenn allowNonExistingEntries auf true steht, wird es hingegen zu den deleted-Objekten gezählt.
     */
    deleteEntry(targetEntry: X | string, allowNonExistingEntries?: boolean) {
        let dataID = null;     
        let existingEntry: X = null;

        if (typeof (targetEntry) == "object" && targetEntry != null) {
            dataID = targetEntry[this.keyAttribute];
        } else if (typeof (targetEntry) == "string") {
            dataID = targetEntry;
        }

        existingEntry = this.getEntityById(dataID);

        if (!dataID) return;

        if (!this.diffdata) this.reset(); // kann/darf ja eigentlich nicht sein. wenns was zu löschen gibt, dann muss es irgendwie initialisiert sein.

        // gabs das vorher?
        let existingIndex = this.getIndexOfDataKey(dataID, "existing");
        

        // überall sonst rauswerfen:
        let i = this.getIndexOfDataKey(dataID, "new");
        while (i != -1) {
            this.diffdata.new.splice(i, 1);
            i = this.getIndexOfDataKey(dataID, "new");
        }

        i = this.getIndexOfDataKey(dataID, "deleted");
        while (i != -1) {
            this.diffdata.deleted.splice(i, 1);
            
            i = this.getIndexOfDataKey(dataID, "deleted");
        }
        this._deletedData[dataID] = null;

        i = this.getIndexOfDataKey(dataID, "changed");
        while (i != -1) {
            this.diffdata.changed.splice(i, 1);
            i = this.getIndexOfDataKey(dataID, "changed");
        }

        // wenns das vorher gab, also wirklich gelöscht wurde, dann in die Liste der gelöschten aufnehmen:
        if (existingIndex != -1) {
            this.diffdata.deleted.push(dataID);
            this._deletedData[dataID] = existingEntry;
        } else if (allowNonExistingEntries === true && !!existingEntry) {
            // vorher noch nicht existierende Objekte sind erlaubt
            this.diffdata.deleted.push(dataID);
            this._deletedData[dataID] = existingEntry;
            this.sourceList.push(existingEntry); // in den Store aufnehmen
        }

        this.emit("deleted");
        this._delayEmitChanged();
    }

    /**
     * Rückgabe: true, wenn erfolgreich eine tatsächliche Änderung im Store ausgeführt wurde, false wenn nicht (zB. bei nicht existierenden Entities)
     * @param data Daten des geänderten Entities
     * @param allowChangeOfNonExistingEntity Wenn true, dann kann auch ein vorher nicht im Store existierendes Objekt geändert werden; außerdem wird ein eigentlich bereits als "new" abgelegtes Objekt ebenfalls ein change-event auslösen, aber weiterhin als "new" deklariert bleiben.
     * @returns
     */
    changeEntry(data: X, allowChangeOfNonExistingEntity?: boolean): boolean {
        let entry = lang.clone(data);
        let dataID = entry[this.keyAttribute];

        if (!dataID) return false;

        if (!this.diffdata) this.reset(); // kann/darf ja eigentlich nicht sein. wenns was zu ändern gibt, dann muss es irgendwie initialisiert sein.

        // gabs noch nicht? dann ist es kein Change, raus:
        let i = this.getIndexOfDataKey(dataID, "existing");
        let bIsNonExistingEntity = i == -1;

        if (allowChangeOfNonExistingEntity !== true && bIsNonExistingEntity == true) {
            return false;
        }


        if (i != -1) { // es hat bereits existiert, dann führt eine Änderung diese Aktionen durch
            // neu kann es nicht sein:
            i = this.getIndexOfDataKey(dataID, "new");
            while (i != -1) {
                this.diffdata.new.splice(i, 1);
                i = this.getIndexOfDataKey(dataID, "new");
            }

            // deleted darf es auch nicht mehr sein:
            i = this.getIndexOfDataKey(dataID, "deleted");
            while (i != -1) {
                this.diffdata.deleted.splice(i, 1);
                i = this.getIndexOfDataKey(dataID, "deleted");
            }
            this._deletedData[dataID] = null;

            // wenn es bereits changed ist, dann raus:
            i = this.getIndexOfDataKey(dataID, "changed");
            while (i != -1) {
                this.diffdata.changed.splice(i, 1);
                i = this.getIndexOfDataKey(dataID, "changed");
            }

            this.diffdata.changed.push(entry);
        } else {
            // Wenn wir hier sind, dann existiert das Entity nicht, aber Ändern von noch nicht existierenden Entities ist erlaubt;
            // d.h. das nicht existierende Entity steht ggf. im new oder changed
            // dann brauchen wir eigentlich nix machen, wir haben das neue Entity einfach geändert und melden das übers change-emit

            if (this.isEntityNew(dataID)) {
                // ist es schon im New? Dann dort ersetzen:
                i = this.getIndexOfDataKey(dataID, "new");
                if (i != -1) {
                    this.diffdata.new.splice(i, 1, entry);
                }
            } else if (this.isEntityDeleted(dataID)) {
                // ist es im delete? dann dort lassen - Änderung von was das gelöscht werden soll macht keinen Sinn?
            } else if (this.isEntityChanged(dataID)) {
                // ist es schon im changed? ersetzen:
                i = this.getIndexOfDataKey(dataID, "changed");
                if (i != -1) {
                    this.diffdata.changed.splice(i, 1, entry);
                }
            } else {
                // es ist noch nirgends - dann nehmen wirs ins change-array mit auf:
                this.diffdata.changed.push(entry);
                this.sourceList.push(entry); // und in die Quellliste aufnehmen
            }
        }

        this.emit("changed");
        this.emit("entityChange", entry);
        this._delayEmitChanged();

        return true;
    }

    getEntityById(ID: string, alternativeKeyAttribute?: string): X {
        let keyAttr = this.keyAttribute;

        if (alternativeKeyAttribute) keyAttr = alternativeKeyAttribute;

        for (let entity of this.getCurrentCompleteList()) {
            if (entity[keyAttr] == ID) {
                return entity;
                break;
            }
        }
    }

    setPropertyValue(objectID: string, propertyPath: string, value: any) {
        this.setEntityAttributeValue(objectID, propertyPath, value);
    }

    setEntityAttributeValue(ID: string, attributepath: string, value: any) {
        let entity = this.getEntityById(ID);
        if (!entity) return;

        let parts = (attributepath || '').split('.');
        // using 'every' so we can return a flag stating whether we managed to set the value.
        if (parts.every(function (p, i) {
            if (!entity) return false; // cancel early as we havent found a nested prop.
            if (i === parts.length - 1) { // we're at the final part of the path.
                entity[parts[i]] = value;
                return true;
            } else {
                entity = entity[parts[i]]; // overwrite the functions reference of the object with the nested one.
            }
        }) == true) {
            this.changeEntry(entity, true);
        }
    }

    private emitHandle: any = null;
    private _delayEmitChanged() {
        if (this.emitHandle != null) clearTimeout(this.emitHandle);

        this.emitHandle = setTimeout(lang.hitch(this, this.emitChange), 30);
    }

    private emitChange() {
        this.emitHandle = null;
        //let dataCopy = this.getDiffData();
        // console.debug(this.id + " emitChange", this.diffdata);
        this.emit("change", this.getCurrentCompleteList());
    }

    private getIndexOfDataKey(keyValue: string, target: "new" | "deleted" | "changed" | "existing", compareAttributePath?: string) {
        if (!keyValue) return -1;

        let keyAttribute = this.keyAttribute;
        if (compareAttributePath) keyAttribute = compareAttributePath;
        if (target == "new") {
            if (this.diffdata?.new?.length) {
                for (let i = 0; i < this.diffdata.new.length; i++) {
                    let entry = this.diffdata.new[i];
                    let value = this.getComplexProperty(entry, keyAttribute);
                    if (value == keyValue) {
                        return i;
                    }
                }
            }
        }

        else if (target == "deleted") {
            if (this.diffdata?.deleted?.length) {

                // ACHTUNG: im deleted stehen nur IDs!
                // compareAttributePath kann ein anderes Attribut anfordern. den Vergleichswert also übersetzen in den eigenen Key!
                if (compareAttributePath) {
                    for (let defaultKeyValue in this._deletedData) {
                        let deletedEntry: X = this._deletedData[defaultKeyValue];
                        
                        let value = this.getComplexProperty(deletedEntry, keyAttribute);

                        if (deletedEntry && value == keyValue) {
                            keyValue = defaultKeyValue;
                            break;
                        }
                    }
                }

                for (let i = 0; i < this.diffdata.deleted.length; i++) {
                    let deletedID = this.diffdata.deleted[i];
                    if (deletedID == keyValue) return i;                    
                }
            }
        }

        else if (target == "changed") {
            if (this.diffdata?.changed?.length) {
                for (let i = 0; i < this.diffdata.changed.length; i++) {
                    let entry = this.diffdata.changed[i];
                    let value = this.getComplexProperty(entry, keyAttribute);
                    if (value == keyValue) {
                        return i;
                    }
                }
            }
        }

        else if (target == "existing") {
            if (this.sourceList?.length) {
                for (let i = 0; i < this.sourceList.length; i++) {
                    let entry = this.sourceList[i];
                    let value = this.getComplexProperty(entry, keyAttribute);
                    if (value == keyValue) {
                        return i;
                    }
                }
            }
        }

        return -1;
    }
  
    postCreate(): void {
        super["postCreate" as any].apply(this, arguments as any);

        this.startup();
    }

    startup(): void {
        super["startup" as any].apply(this, arguments as any);
    }
}

export default mdsWidget(EntityStore);